var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-items-center flex-wrap px-4" },
    [
      _c("hr", { staticClass: "w-100 my-2" }),
      _c("div", { staticClass: "w-100 d-flex justify-content-between" }, [
        _c("div", { staticClass: "notification-date" }, [
          _vm._v(" " + _vm._s(_vm.date) + " ")
        ]),
        _c(
          "button",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("remove", _vm.notification, null)
              }
            }
          },
          [_vm._v(" ❌ ")]
        )
      ]),
      _c(
        "div",
        {
          staticClass: "w-100 d-flex align-items-center pt-1",
          class: { "notification-link": _vm.url },
          on: { click: _vm.handleClick }
        },
        [
          _c("img", {
            staticClass: "d-block",
            attrs: { width: "50", src: _vm.iconUrl }
          }),
          _vm.notificationMarkdown
            ? [
                _c("omegaup-markdown", {
                  attrs: { markdown: _vm.notificationMarkdown }
                })
              ]
            : _vm.url
            ? _c("div", [
                _c("a", { attrs: { href: _vm.url } }, [
                  _vm._v(" " + _vm._s(_vm.text) + " ")
                ])
              ])
            : _c("div", [_vm._v(" " + _vm._s(_vm.text) + " ")])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }